import React, {useState} from "react";
import {Link, useNavigate} from "react-router-dom";
import {toast} from "react-toastify";
import axios from "axios";
import {publicApi} from "../api";

function ForgotPassword() {
    localStorage.removeItem("focus")
    const navigate = useNavigate();

    const [email, setEmail] = useState("");

    const handleReset = async (event: React.SubmitEvent<HTMLFormElement>) => {
        event.preventDefault();
        if (!email.trim()) return toast.error("Email non può essere vuota");

        try {
            await publicApi.delete(`/v1/user/${encodeURIComponent(email)}/password`);

            navigate("/login");
            toast.success("Reset password eseguito con successo");
        } catch (err) {
            if (axios.isAxiosError(err)) {
                const message =
                    err.response?.data?.message ||
                    "Errore lato server";
                toast.error(message);
            } else {
                toast.error("Errore non gestito");
            }
        }
    }
    return (
        <div className="bg-blue-50 flex items-center justify-center min-h-screen">
            <div className="bg-white shadow-lg rounded-2xl p-8 w-full max-w-md">
                {/*Title*/}
                <h2 className="text-3xl font-bold text-center text-blue-600 mb-6">
                    Casablanca Riparazioni
                </h2>

                {/*Form*/}
                <form className="space-y-5"
                      onSubmit={handleReset}>

                    {/*Email*/}
                    <div>
                        <label className="block text-gray-600 mb-1">Username o Email</label>
                        <input placeholder="you@example.com"
                               className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                               onChange={(event) => setEmail(event.target.value)}/>
                    </div>

                    {/*Button*/}
                    <button type="submit"
                            className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition duration-200">
                        Reset Password
                    </button>
                    <div className="flex items-center justify-between text-sm">
                        <Link to={"/login"} className="text-blue-600 hover:underline">Area riservata</Link>
                    </div>

                </form>
            </div>
        </div>
    )
}

export default ForgotPassword;